import * as React from 'react';
import { Col, Row } from 'reactstrap';
import ErrorInformer from './feature/ErrorInformer';

const Page = (props: any) => {

    return (
        <React.Fragment>
            <Row>
                <Col>
                    <ErrorInformer error={props.error} setError={props.setError}>
                        {(props.children)}
                    </ErrorInformer>
                </Col>
            </Row>            
        </React.Fragment>
    );
}

export default Page;